import { useQuery } from '@tanstack/react-query';
import { clientIdentityGetOptions } from '@visiba/api-vcs-client-v2';

export const useRepresentablePatients = (options: { enabled?: boolean } = {}) => {
	const { data, error, isLoading } = useQuery({ ...clientIdentityGetOptions(), enabled: options.enabled });
	const representablePatients = data?.Data?.CanRepresent ?? [];
	const currentlyRepresentedPatient = representablePatients.find((patient) => patient.Id === data?.Data?.RepresentingId) ?? null;

	const hasUnresolvedRepresentation = data?.Data?.RepresentingId != null && currentlyRepresentedPatient === null;
	return { currentlyRepresentedPatient, representablePatients, error, isLoading, hasUnresolvedRepresentation };
};
